import React from 'react';
import { motion } from 'framer-motion';
interface EBTFilterProps {
  isEnabled: boolean;
  onToggle: (enabled: boolean) => void;
}
export function EBTFilter({
  isEnabled,
  onToggle
}: EBTFilterProps) {
  return <div className="flex items-center justify-between bg-white p-3 rounded-xl shadow-sm border border-gray-100" data-id="element-237">
      <div className="flex flex-col" data-id="element-238">
        <span className="font-semibold text-gray-900 text-sm" data-id="element-239">
          EBT Eligible Only
        </span>
        <span className="text-xs text-gray-500" data-id="element-240">
          Show items you can buy with SNAP
        </span>
      </div>
      <button onClick={() => onToggle(!isEnabled)} className={`relative inline-flex h-7 w-12 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-[#1D3557] focus:ring-offset-2 ${isEnabled ? 'bg-[#1D3557]' : 'bg-gray-200'}`} role="switch" aria-checked={isEnabled} aria-label="Toggle EBT eligible items only" data-id="element-241">
        <motion.span layout transition={{
        type: 'spring',
        stiffness: 500,
        damping: 30
      }} className={`inline-block h-5 w-5 transform rounded-full bg-white shadow-sm ring-0 ${isEnabled ? 'translate-x-6' : 'translate-x-1'}`} data-id="element-242" />
      </button>
    </div>;
}